<div class="iwb-visual-editor" [class.iwb-visual-editor--fill]="fill">
  <div
    class="iwb-visual-editor__toolbar"
    role="toolbar"
    aria-label="Formatting">
    <div class="iwb-visual-editor__group">
      <select
        class="iwb-visual-editor__block"
        aria-label="Text style"
        (change)="
          formatBlock($any($event.target).value); $any($event.target).value = ''
        ">
        <option value="" selected>Style…</option>
        <option value="p">Paragraph</option>
        <option value="h1">Heading 1</option>
        <option value="h2">Heading 2</option>
        <option value="h3">Heading 3</option>
      </select>
    </div>

    <div class="iwb-visual-editor__group">
      <button
        type="button"
        title="Bold"
        aria-label="Bold"
        (click)="exec('bold')">
        <b>B</b>
      </button>
      <button
        type="button"
        title="Italic"
        aria-label="Italic"
        (click)="exec('italic')">
        <i>I</i>
      </button>
      <button
        type="button"
        title="Underline"
        aria-label="Underline"
        (click)="exec('underline')">
        <u>U</u>
      </button>
    </div>

    <div class="iwb-visual-editor__group">
      <button
        type="button"
        title="Bulleted list"
        aria-label="Bulleted list"
        (click)="exec('insertUnorderedList')">
        &bull; List
      </button>
      <button
        type="button"
        title="Numbered list"
        aria-label="Numbered list"
        (click)="exec('insertOrderedList')">
        1. List
      </button>
    </div>

    <div class="iwb-visual-editor__group">
      <button
        type="button"
        title="Insert link"
        aria-label="Insert link"
        [class.is-active]="showLinkInput"
        (click)="toggleLinkInput()">
        🔗 Link
      </button>
      <button
        type="button"
        title="Insert image"
        aria-label="Insert image"
        [class.is-active]="showImageInput"
        (click)="toggleImageInput()">
        🖼 Image
      </button>
      <button
        type="button"
        title="Clear formatting"
        aria-label="Clear formatting"
        (click)="exec('removeFormat')">
        Clear
      </button>
    </div>

    <div class="iwb-visual-editor__group" *ngIf="variables.length">
      <select
        class="iwb-visual-editor__variables"
        aria-label="Insert variable"
        (change)="
          insertVariable($any($event.target).value);
          $any($event.target).value = ''
        ">
        <option value="" selected>Insert variable…</option>
        <option
          *ngFor="let variable of orderedVariables()"
          [value]="variable.value">
          {{ variable.label }}
        </option>
      </select>
    </div>

    <div class="iwb-visual-editor__group" *ngIf="freemarkerSnippets.length">
      <select
        class="iwb-visual-editor__variables"
        aria-label="Insert Freemarker"
        (change)="
          insertFreemarker($any($event.target).value);
          $any($event.target).value = ''
        ">
        <option value="" selected>Insert Freemarker…</option>
        <option
          *ngFor="let item of freemarkerSnippets"
          [value]="item.snippet"
          [title]="item.description">
          {{ item.label }}
        </option>
      </select>
    </div>

    <div
      class="iwb-visual-editor__group"
      *ngIf="starterTemplates.length && isEmpty">
      <select
        class="iwb-visual-editor__starters"
        aria-label="Start from a template"
        (change)="
          applyStarter($any($event.target).value);
          $any($event.target).value = ''
        ">
        <option value="" selected>Start from a template…</option>
        <option
          *ngFor="let template of starterTemplates"
          [value]="template.id"
          [title]="template.description">
          {{ template.name }}
        </option>
      </select>
    </div>
  </div>

  <div class="iwb-visual-editor__input-row" *ngIf="showLinkInput">
    <input
      type="url"
      class="iwb-visual-editor__url"
      placeholder="https://example.com — select text first, then add the link"
      [(ngModel)]="linkDraft"
      (keydown.enter)="applyLink()" />
    <button type="button" (click)="applyLink()">Add link</button>
  </div>

  <div class="iwb-visual-editor__input-row" *ngIf="showImageInput">
    <input
      type="url"
      class="iwb-visual-editor__url"
      placeholder="https://example.com/image.png"
      [(ngModel)]="imageDraft"
      (keydown.enter)="applyImage()" />
    <button type="button" (click)="applyImage()">Insert image</button>
  </div>

  <div class="iwb-visual-editor__warning" *ngIf="!supported" role="alert">
    This template uses advanced Freemarker that may not survive visual editing.
    Switch to the HTML editor to change it safely.
  </div>

  <iframe
    class="iwb-visual-editor__surface"
    title="Email body editor"
    sandbox="allow-same-origin"
    [srcdoc]="frameSrcdoc"
    (load)="onFrameLoad($event)"></iframe>

  <div
    class="iwb-visual-editor__chip-editor"
    *ngIf="isEditingChip && chipPopoverPos"
    role="dialog"
    aria-label="Edit Freemarker"
    [style.left.px]="chipPopoverPos.x"
    [style.top.px]="chipPopoverPos.y">
    <label class="iwb-visual-editor__chip-label">
      Edit Freemarker
      <textarea
        rows="2"
        class="iwb-visual-editor__chip-input"
        aria-label="Freemarker source"
        [(ngModel)]="chipDraft"
        (keydown.escape)="closeChipEditor()"
        (keydown.control.enter)="saveChipEdit()"></textarea>
    </label>
    <p class="iwb-visual-editor__chip-error" *ngIf="chipError" role="alert">
      {{ chipError }}
    </p>
    <div class="iwb-visual-editor__chip-actions">
      <button type="button" (click)="saveChipEdit()">Save</button>
      <button type="button" (click)="removeChip()">Remove</button>
      <button type="button" (click)="closeChipEditor()">Cancel</button>
    </div>
  </div>
</div>
